import React from 'react';
import { Card } from 'antd';
import { injectIntl } from 'react-intl';
import { observer } from 'mobx-react';
import { map, startCase } from 'lodash';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import getSymbol from '../../../constants/propertySymbols';
import { propsToDisplay } from './PricingCardPropsToDisplay';
import currencies from '../../../constants/currency';
import { themeColors } from '../../../constants/themes';

const boxShadowColor =
  process.env.APP_NAME === 'TRIPLEMARS' ? 'rgba(71, 69, 136, 0.11)' : '#ebd1d1';

const CustomCard = styled(Card)`
  background: ${themeColors.backgroundDarkGray};
  width: 31%;
  ${''} display: flex;
  flex-direction: column;
  cursor: pointer;
  min-height: 200px;
  box-shadow: 0px 1px 6px 0 ${boxShadowColor};
  & .ant-card-head-title {
    padding: 13px 0 5px;
  }
`;

const PricingCard = ({ handleClick, pricing: rows, type, intl }) => (
  <CustomCard
    bordered={false}
    headStyle={{ margin: '0 24px', padding: '0' }}
    bodyStyle={{ padding: '1em 24px' }}
    title={<div className="title3">{intl.formatMessage({ id: `pricing.${type}` })}</div>}
    onClick={handleClick}
  >
    {type === 'rangedProfit' && !rows.length && <h2>Please connect a destination account</h2>}

    {type === 'rangedProfit'
      ? /* eslint-disable */
        rows.map(({ maxValue, minValue, formattedProfit, formattedBreakEven, currency }) => (
          <div
            key={`${minValue}${maxValue}`}
            css={css`
              white-space: pre;
            `}
          >
            {`${currencies[currency].symbol}${minValue}->${currencies[currency].symbol}${maxValue}`}
            <p>{`Break Even: ${formattedBreakEven}, Profit: ${formattedProfit}`}</p>
          </div>
        ))
      : map(
          propsToDisplay[type],
          (value, key) =>
            !isNaN(rows[key]) && ( // eslint-disable-line
              <div key={key}>
                {startCase(value)} : {rows[key]}
                {getSymbol(key, rows.profitType)}
              </div>
            ),
        )
    /* eslint-enable */
    }
  </CustomCard>
);

PricingCard.propTypes = {
  pricing: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  handleClick: PropTypes.func,
  type: PropTypes.string,
  intl: PropTypes.object,
};

export default injectIntl(observer(PricingCard));
